import i18n from '../../i18n'

const WEEKDAYS_LONG = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat']

const WEEKDAYS_SHORT = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat']

const MONTHS = [
    'january',
    'february',
    'march',
    'april',
    'may',
    'june',
    'july',
    'august',
    'september',
    'october',
    'november',
    'december'
]

export function formatDay(day) {
    return day.toDateString()
}

export function formatMonthTitle(d) {
    return `${i18n.t('months.' + MONTHS[d.getMonth()])} ${d.getFullYear()}`
}

export function formatWeekdayShort(i) {
    return i18n.t('weekDaysShort.' + WEEKDAYS_SHORT[i])
}

export function formatWeekdayLong(i) {
    return i18n.t('weekDaysLong.' + WEEKDAYS_LONG[i])
}

export function getFirstDayOfWeek() {
    return 0
}

export function getMonths() {
    return MONTHS.map(month => i18n.t('month.' + month))
}

export default {
    formatDay,
    formatMonthTitle,
    formatWeekdayShort,
    formatWeekdayLong,
    getFirstDayOfWeek,
    getMonths
}



// WEBPACK FOOTER //
// ./components/Datepicker/LocaleUtils.js